import { CheckCircle2, AlertCircle } from 'lucide-react';

import { fmt, fmtClock, fmtRelative } from '../utils/format';

// Failed jobs list. If there are no failures at all, shows a friendly green
// empty state. Otherwise a scrollable list of recent exceptions.
export const FailedJobsList = ({ failed = { total: 0, recent: [] } }) => {
  const total = failed?.total ?? 0;
  const recent = failed?.recent ?? [];

  if (total === 0) {
    return (
      <div className="flex flex-col items-center gap-2 py-8 text-center">
        <CheckCircle2 size={20} className="text-greenColor" />
        <span className="text-xs text-blackColor font-medium">No failures</span>
        <span className="text-[11px] text-darkGrayColor">
          All jobs are processing cleanly.
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 text-[11px] text-darkGrayColor">
        <AlertCircle size={12} className="text-redColor" />
        <span>
          <span className="text-redColor font-semibold">{fmt(total)}</span> total ·{' '}
          showing {recent.length}
        </span>
      </div>
      <ul className="flex flex-col gap-1.5 max-h-80 overflow-y-auto pr-1">
        {recent.map(job => (
          <li
            key={job.id}
            className="flex flex-col gap-1 px-2.5 py-2 rounded border border-gray-100 bg-white hover:bg-lightestGrayColor transition-colors"
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className="text-[11px] font-mono font-medium text-redColor truncate">
                {job.exception_class}
              </span>
              <span
                className="text-[10px] text-darkGrayColor whitespace-nowrap"
                title={fmtClock(job.failed_at)}
              >
                {fmtRelative(job.failed_at)} ago
              </span>
            </div>
            <span
              className="text-[11px] text-blackColor line-clamp-2 break-words"
              title={job.exception_message}
            >
              {job.exception_message}
            </span>
            <div className="flex items-center gap-2 text-[10px] text-darkGrayColor">
              <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-lightGrayColor">
                {job.queue}
              </span>
              <span>#{job.id}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
